import React from 'react';
import IconButton from './IconButton';

const ButtonWithIcon = ({ Icon, onClick, className }) => (
    <IconButton
        Icon={Icon}
        onClick={onClick}
        className={className}
    />
);

export default ButtonWithIcon;
